module.exports = __webpack_public_path__ + "img/Feature.a22b2dc1.jpg";